import React from 'react';
import {Container, Row, Col, Carousel, Button} from 'react-bootstrap';
import Navbar from './Navbar.js';
import Footer from './Footer.js';
import Header from './Header.js';
import './css/customThemes.css';
import Collage from '../res/imgs/site/Collage.png';
import Collection from '../res/imgs/site/Collection.png';
import Moss from '../res/imgs/site/Moss.png';
import Lake from '../res/imgs/site/Lake.png';
import MapButton from '../res/imgs/site/MapButton.png';
import MolNetButton from '../res/imgs/site/MolNetButton.png';
import Diagram from '../res/imgs/site/Diagram.png';

export default function HomeSite(){
    return (
      <div>
        <br/>
        <br/>
        <Container style={{width: "85%"}} fluid>
         <Header/>
          <br/>
          <br/>
          <Row >
            <Navbar />
          </Row>
          <Row>
            <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={ Collage }
                alt="Part of the species collected"
              />
              <Carousel.Caption>
                <h3>Species collected for analysis</h3>
                <p className='slides' >Eukaryote, prokaryote</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={ Collection }
                alt="Second slide"
              />
              <Carousel.Caption>
                <h3>Plant collection in Valle de Guadalupe</h3>
                <p className='slides'>B.C. México</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={ Moss }
                alt="Third slide"
              />
              <Carousel.Caption>
                <h3>Bryophyta</h3>
                <p className='slides'>Common name: Green moss</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={ Lake }
                alt="First slide"
              />
              <Carousel.Caption>
                <h3>Poza Azul in Cuatro Ciénagas</h3>
                <p className='slides'>Coahuila, México</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </Row>
        <br/>
        <Row >
          <Button href="/map" className="card" style={{border:0, background:"transparent"}}><img src={ MapButton } alt="button 1 (Map)"/></Button>
        </Row>
        <br/>
        <Row>
          <Button href="/molnet" className="card" style={{border:0, background:"transparent"}}><img src={ MolNetButton } alt="button 2 (Molecular Network)"/></Button>
        </Row>
        <Row>
            
        </Row>
        <br/>
        <br/>
        <Row id="about">
          <Col>
            <div class="col-md-12">
              <h2 className="title-subtext">
                MISSION
              </h2>
              <hr class="solid"></hr>
              <p class= "homepage">
                Strength the metabolomics field in México by accelerating the understanding, through multi-
                institutional collaboration, of the chemical diversity of the species that inhabit México and
                developing a platform of chemical data visualization to the Mexican community.             
              </p>
				    </div>
          </Col>
        </Row>
        <br/>
        <br/>
        <Row>
            <Col>
              <div class="col-md-12">
                <h2 className="title-subtext">
                  VISION
                </h2>
                <hr class="solid"></hr>
                <p class= "homepage">
                  Construct the chemical diversity map of the species inhabiting México.
                </p>
            </div>
          </Col>
        </Row>
        <br/>
        <br/>
        <br/>
        <Row className="justify-content-md-center">
          <Col>
            <h2 className="title-subtext" >
                DESCRIPTION
              </h2>
              <hr class="solid"></hr>
              <p class= "homepage">
                The Mexico Project is an initiative undertaken, in 2020, by the MS2 Laboratory
                https://usuario.cicese.mx/~amoreno/ (Department of Biomedical Innovation at CICESE) that
                attempts to characterize the metabolomes (i.e., collection of chemical entities or metabolites in
                a biological system) of certain terrestrial and marine species that inhabit the Mexican territory
                and generate a platform to visualize the chemical knowledge repertoire of the species. 
              </p>
              <p class="homepage">
                The current problem or bottleneck in investigating natural products and their
                biological effects are technical and analytical challenges in identifying the compounds present
                in the species (extracts) and limited access to the specialized infrastructure required to
                accomplish such a task. Therefore, the Mexico Project aims to construct a multi-collaborative
                group to generate and analyze metabolomics data of select species and share, with the
                community, the retrieved knowledge to accelerate the discovery of new potential drugs from
                natural sources and contribute to understanding the species at the chemical level.
              </p>
              <p class="homepage">
                A fundamental part of the Project is the generation of data using liquid
                chromatography coupled to high-resolution tandem mass spectrometry (LC-HR-MS2) and
                chemoinformatics analysis by enthusiastic young researchers who seek to generate scientific
                knowledge for the benefit of research in Mexico.
              </p>
                <img
              className="d-block w-100"
              src={ Diagram }
              alt="Flyer de METXICO"
            />
          </Col>
        </Row>
        <Row>
          <Col>
          <Footer/>
            </Col>
        </Row>
      </Container> 
      </div>
      );
}